import { GatsbyBrowser } from "gatsby";
import React from "react";
import { CookiesProvider } from "react-cookie";

const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
  <CookiesProvider>{element}</CookiesProvider>
);

export default wrapRootElement;
